export default __webpack_public_path__ + "static/media/fileExcel.cd16faea.svg";